export function lastDayOfMonth(date = new Date()): Date {
    // getMonth is 0-indexed
    let d = new Date(`${date.getFullYear()}-${(date.getMonth() + 2).toString().padStart(2, '0')}-01`);
    d.setDate(0);
    return d;
}
